import { Controller } from '@hotwired/stimulus'

/**
 * Usage: <%= form_with(url:, model:, method: :post, html: { data: { controller: 'form' } }) do |f| %>
 * */

export default class extends Controller {
  static targets = ['submitButton']

  get submitButton() {
    if (this.hasSubmitButtonTarget) return this.submitButtonTarget
    return this.element.querySelector('input[type="submit"]')
  }

  // Intended to use when declaring the form.
  //
  // Example:
  //   <%=
  //     form_with(
  //       url: url, model: model, method: method,
  //       html: {
  //         id: 'sample-id',
  //         data: { controller: 'form', action: 'turbo:submit-end->form#reDisableSubmit' }
  //       }
  //     ) do |f|
  //   %>
  //     <%# ... %>
  //   <% end %>
  reDisableSubmit(event) {
    if (event.detail.fetchResponse.response.redirected === true)
      this.submitButton.disabled = true
  }
}
